import { render, staticRenderFns } from "./CardPostItem.vue?vue&type=template&id=7a8627cb&"
import script from "./CardPostItem.vue?vue&type=script&lang=js&"
export * from "./CardPostItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports